import { P2GBox, P2GButton, P2GDropdown, P2GText } from '@parcel2go/core-ui';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FindCountry } from '~/apps/smartsend/lib/cache/CountryCache';
import { Customer } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  customer: Customer;
  onSave: (customer: Customer) => void;
  fallback?: React.ReactNode;
}

const QuickFixCounty: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [selection, setSelection] = useState<string | undefined>(undefined);
  const counties = useMemo(() => {
    const c = FindCountry(props.customer);
    if (c?.States?.length > 0) {
      return c.States.map((s) => ({ value: s.Code, text: s.Name }));
    }
    return [];
  }, [props.customer]);

  useEffect(() => {
    if (selection === undefined && counties?.length > 0) {
      setSelection(counties[0].value);
    }
  }, [counties, selection]);

  if (counties?.length > 0) {
    return (
      <>
        <P2GText variant="body2">
          <strong>{props.customer.County}</strong> was imported, but needs to match the following:
        </P2GText>
        <P2GBox display="flex" flexDirection="row" alignItems="center" gap={2}>
          <P2GDropdown
            fullWidth
            required={false}
            options={counties || []}
            value={selection || ''}
            label={t('COUNTY_LABEL', { defaultValue: 'County' })}
            key={'County'}
            id={'County'}
            onChange={(v: string) => setSelection(v)}
          />
          <P2GButton
            variant="primary"
            style={{ minWidth: 'auto' }}
            disabled={!selection}
            onClick={() => props.onSave({ ...props.customer, County: selection })}
          >
            {t('UPDATE_BUTTON', { defaultValue: 'Update' })}
          </P2GButton>
        </P2GBox>
      </>
    );
  }

  return <>{props.fallback}</>;
};

export default QuickFixCounty;
